import { render, staticRenderFns } from "./ProjectTaskInfo.vue?vue&type=template&id=77b58706"
import script from "./ProjectTaskInfo.vue?vue&type=script&lang=js"
export * from "./ProjectTaskInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports